import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ClMessages } from '@corelabs/angular/ui';

import { LoaderService } from '@shared/components';
import { UpdateNotifierComponent } from './update-notifier/update-notifier.component';
import { LanguageService } from './i18n';
import { AccountMessagesService } from './core/libraries';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, ClMessages, UpdateNotifierComponent],
    providers: [AccountMessagesService],
})
export class AppComponent implements OnInit {
    readonly loaderService = inject(LoaderService);
    private readonly languageService = inject(LanguageService);
    private readonly accountMessagesService = inject(AccountMessagesService);

    ngOnInit(): void {
        this.languageService.init();
    }
}
